var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniversityGeneralAvgannualgradsalary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.449,
    height: 58.328,
    viewBox: "0 0 43.449 58.328",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "money-bag_1_",
    "data-name": "money-bag (1)",
    transform: "translate(0 -10.827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48234",
    "data-name": "Group 48234",
    transform: "translate(0 10.827)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55614",
    "data-name": "Path 55614",
    d: "M42.469,184.4l-.292-1.454L35.907,167.5l-1.287-1.428q-.379-.37-.744-.7c-1.2-.865-3.761-3.623-7.343-3.623l-1.358-1.12H18.093l-1.177,1.12c-3.586,0-5.656,2.375-7.339,3.625-3.3,3.073-6.877,7.466-7.608,12.656L.1,190.108a8.288,8.288,0,0,0,8.191,9.555h26.87a8.288,8.288,0,0,0,8.191-9.551Z",
    transform: "translate(0 -141.334)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55615",
    "data-name": "Path 55615",
    d: "M189.97,41.465l-4.637-.921-.665,10.34.538.848h1.94l.43-.746,3.307-8.421a.929.929,0,0,0-.913-1.1Z",
    transform: "translate(-160.883 -36.716)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55616",
    "data-name": "Path 55616",
    d: "M108.166,51.732h1.741l.617-.848-.762-10.34-4.539.921a.929.929,0,0,0-.913,1.1l3.307,8.421Z",
    transform: "translate(-90.86 -36.716)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55617",
    "data-name": "Path 55617",
    d: "M144.106,10.827c-1.368,0-3.869.385-3.619,1.726l1.554,12.441.725.848h2.792l.6-.848,1.554-12.441C147.967,11.206,145.479,10.827,144.106,10.827Z",
    transform: "translate(-122.377 -10.827)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55618",
    "data-name": "Path 55618",
    d: "M6.315,197.68,8.183,185.6c.732-5.189,4.3-9.582,7.608-12.656,1.684-1.25,3.754-3.625,7.339-3.625H16.915c-3.586,0-5.656,2.375-7.339,3.625-3.3,3.073-6.877,7.466-7.608,12.656L.1,197.68a8.288,8.288,0,0,0,8.191,9.555h6.216a8.288,8.288,0,0,1-8.191-9.555Z",
    transform: "translate(0 -148.906)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55628",
    "data-name": "Path 55628",
    d: "M127.16,127.07h-8.523a2.505,2.505,0,0,1-2.505-2.505v-1.236a2.505,2.505,0,0,1,2.505-2.505h8.523a2.505,2.505,0,0,1,2.505,2.505v1.236A2.505,2.505,0,0,1,127.16,127.07Z",
    transform: "translate(-101.174 -106.655)",
    fill: "#aee0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55629",
    "data-name": "Path 55629",
    d: "M121.439,124.564v-1.236a2.505,2.505,0,0,1,2.505-2.505h-5.307a2.505,2.505,0,0,0-2.505,2.505v1.236a2.505,2.505,0,0,0,2.505,2.505h5.307A2.505,2.505,0,0,1,121.439,124.564Z",
    transform: "translate(-101.174 -106.655)",
    fill: "#dff9ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_55631",
    "data-name": "Path 55631",
    d: "M136.232,238.072a1,1,0,0,0-1,1v2.153a3.977,3.977,0,0,0,.176,7.949h1.638a1.986,1.986,0,0,1,0,3.973H135.2a1.688,1.688,0,0,1-1.627-1.211,1,1,0,0,0-1.906.572,3.666,3.666,0,0,0,3.533,2.629h.033v2.149a1,1,0,0,0,1.99,0v-2.153a3.977,3.977,0,0,0-.176-7.949h-1.638a1.986,1.986,0,0,1,0-3.972h1.463a1.688,1.688,0,0,1,1.627,1.21,1,1,0,1,0,1.906-.572,3.663,3.663,0,0,0-3.182-2.613v-2.165A1,1,0,0,0,136.232,238.072Z",
    transform: "translate(-110.72 -198.081)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityGeneralAvgannualgradsalary);
export default __webpack_public_path__ + "static/media/university-general-avgannualgradsalary.04e5c093cd9b15052f41c0d77a74c7de.svg";
export { ForwardRef as ReactComponent };